// 值处理
import {merge, assignWith, cloneDeep, isUndefined, isPlainObject} from 'lodash-es'
import {checkObjectAttr, getObjectStringList, getFieldObject} from './base'
import { LAYOUT_TYPE } from '../../constants/index'

let formattingValue

// 解析 a.b.c格式
const apiNameHandle = (data, apiName, value) => {
  let idx = 0
  const keys = apiName.split('.')
  const keyLen = keys.length
  const fun = (obj, key) => {
    idx++

    if (idx === keyLen) {
      obj[key] = obj[key] || value
      return
    }

    if (!obj[key]) {
      obj[key] = {}
    }
    fun(obj[key], keys[idx])
  }

  fun(data, keys[idx])

  return data
}

// 递归合并值
function _assignWith (object, sources) {
  return assignWith(object, sources, (objValue, srcValue) => {
    // 如果当object没有值 使用sources的值
    if (isUndefined(objValue)) {
      return srcValue
    }
    // 如果当期对象是 使用sources的值
    if (isPlainObject(objValue) && isPlainObject(srcValue)) {
      return _assignWith(objValue, srcValue)
    }
    return objValue
  })
}

// 处理从对象
function processSub (subRelevance, formData, isPolymeric) {
  let result = []
  // key 数据id
  Object.keys(subRelevance).forEach(key => {
    let cell = {
      ...subRelevance[key],
      dataKey: key
    }
    if (isPolymeric) {
      const {data, fieldMap} = cell
      delete formData[key]
      result = data.length > 0 ? data.map(row => merge(formattingValue(row, fieldMap, false), formData)) : [formData]
    } else {
      formData[key] = formattingSub(cell, formData, isPolymeric)
    }
  })
  return result
}

// 从对象生成后端需要数据格式 {addRecords,updateRecords,deleteRecords}
function formattingSub ({data, fieldMap, dels, dataKey}) {
  // 聚合页面
  let addRecords = []
  let updateRecords = []
  // 编辑
  data.forEach(row => {
    const flag = String(row.aPaaS_SequenceId).includes(`${dataKey}_CREATE`)
    const newRow = formattingValue(row, fieldMap, !flag)
    flag ? addRecords.push(newRow) : updateRecords.push(newRow)
  })
  return {addRecords, updateRecords, deleteRecords: dels}
}

// 处理 主对象
function propcessMain ({ formData, fieldMap }) {
  return formattingValue(formData, fieldMap)
}

function createdFormattingValue (isEdit, isPackage) {
  // 格式化值
  return (formData, fieldMap, _isEdit) => {
    // 从对象取_isEdit 主对象取 isEdit
    isEdit = isUndefined(_isEdit) ? isEdit : _isEdit
    const newFormData = {}
    // 处理发货单从对象附件详情组件展示的时候数据为空问题
    formData = cloneDeep(formData)
    let _formData = {}
    // package 对象不过滤
    if (isPackage) {
      _formData = cloneDeep(formData)
      delete _formData.custom__
    }
    // _updated ？？
    // 数据处理方式
    for (let key in fieldMap) {
      let field = fieldMap[key]
      let {apiName, attr} = field
      if (isUndefined(apiName) || field?.props?.pageShow === false) { continue }
      let objStringList = getObjectStringList(apiName)
      let lastObjString = objStringList[objStringList.length - 1]
      if (field.__innerField || field.__isUse || checkObjectAttr(_formData, objStringList)) {
        let fieldObject = getFieldObject(formData, objStringList) // 获取最后一级对象
        // 判断有没有对当前类型的值处理
        fieldObject[lastObjString] = attr?.submitValue(fieldObject[lastObjString], field, isEdit)
        apiNameHandle(newFormData, apiName, fieldObject[lastObjString])
      }
    }
    _assignWith(newFormData, _formData)
    if (isEdit) {
      newFormData.aPaaS_SequenceId = formData.aPaaS_SequenceId
    } else {
      delete newFormData.aPaaS_SequenceId
    }
    return newFormData
  }
}

// 获取值入口
export default function submitDataHandle (params) {
  const {mainRecord, subRelevance, isEdit = false, isPackage = true, layoutType} = params
  const isPolymeric = layoutType === LAYOUT_TYPE.LAYOUT_TYPE_POLYMERIC_CREATE
  // 注入 isEdit, isPackage 参数
  formattingValue = createdFormattingValue(isEdit, isPackage)
  // 处理主对象
  const data = propcessMain(mainRecord)
  // 处理从对象
  const subResult = processSub(subRelevance, data, isPolymeric)
 
  return isPolymeric ? subResult : data
}